const statsData = [
	/* Constant stats (not saved in game stats object) */
	{
		id: 'rent-and-utilities',
		dictionaryId: '',
		title: {
			da: 'Husleje, el, vand og varme',
			kl: 'Inimut akiliutissaq, kallerup innera, imeqarneq kiassarnerlu',
		},
		type: 'number',
		unit: {
			da: 'kr',
			kl: 'kr',
		},
		value: 57000
	},
	{
		id: 'website',
		dictionaryId: '',
		title: {
			da: 'Website',
			kl: 'Nittartagaq',
		},
		type: 'number',
		unit: {
			da: 'kr',
			kl: 'kr',
		},
		value: 500
	},
	{
		id: 'owner-salary',
		dictionaryId: '',
		title: {
			da: 'Løn til ejere',
			kl: 'Piginnittunut akissarsiassat',
		},
		type: 'number',
		unit: {
			da: 'kr / person',
			kl: 'kr / inummut ataatsimut',
		},
		value: 3*15000
	},

	/* Basic stats - affected by selected actions and/or ending a round - displayed */
	{
		id: 'stock',
		dictionaryId: 'stock',
		title: {
			da: 'Lager',
			kl: 'Toqqorsivik',
		},
		type: 'number',
		unit: {
			da: 'stk',
			kl: '-nik amerlassusillit',
		},
		initialValue: 400
	},
	{
		id: 'purchase-price',
		dictionaryId: 'purchase-price',
		title: {
			da: 'Indkøbspris',
			kl: 'Pisiarinerani akia',
		},
		type: 'number',
		unit: {
			da: 'kr/stk',
			kl: 'kr/ataaseq',
		},
		initialValue: 25
	},
	{
		id: 'production-price',
		dictionaryId: 'prod-price',
		title: {
			da: 'Prod.-omkostninger',
			kl: 'Nioqqutissiornermut aningaasartuutit',
		},
		type: 'number',
		unit: {
			da: 'kr',
			kl: 'kr',
		},
		initialValue: 12
	},
	{
		id: 'marketing-effect',
		dictionaryId: '',
		title: {
			da: 'Kendskab',
			kl: 'Ilisimasat',
		},
		type: 'range',
		minVal: 1,
		maxVal: 10,
		initialValue: 3
	},
	{
		id: 'experience',
		dictionaryId: '',
		title: {
			da: 'Butiksoplevelse',
			kl: 'Pisiniarfimmi misigisaq',
		},
		type: 'range',
		minVal: 1,
		maxVal: 10,
		initialValue: 4
	},


	/* Basic stats - affected by selected actions and/or ending a round - hidden */
	{
		id: 'supplier-base',
		initialValue: 'tshirt-supplier-a',
	},
	{
		id: 'purchase-base',
		dictionaryId: '',
		title: {
			da: 'Indkøb',
			kl: 'Pisiniarneq',
		},
		type: 'number',
		unit: {
			da: 'stk',
			kl: '-nik amerlassusillit',
		},
		initialValue: 200
	},
	{
		id: 'sales-price-base',
		dictionaryId: '',
		title: {
			da: 'Salgspris',
			kl: 'Tuninerani akia',
		},
		type: 'number',
		unit: {
			da: 'kr',
			kl: 'kr',
		},
		initialValue: 350
	},
	{
		id: 'customers-prev-round',
		dictionaryId: '',
		title: {
			da: 'Kunder sidste kvartal',
			kl: 'Ukiup sisamararterutaani kingullermi pisiniartut',
		},
		type: 'number',
		unit: null,
		initialValue: 4500
	},
	{
		id: 'prod-capacity-base',
		dictionaryId: '',
		title: {
			da: 'Prod.-kapacitet',
			kl: 'Nioqqutissat amerlassuserisinnaasaat',
		},
		type: 'number',
		unit: {
			da: 'stk',
			kl: '-nik amerlassusillit',
		},
		initialValue: 600
	},
	{
		id: 'quality-score-base',
		dictionaryId: '',
		title: {
			da: 'Kvalitetsscore',
			kl: 'Pitsaassutsip nalilernera',
		},
		type: 'number',
		unit: null,
		initialValue: 2
	},
	{
		id: 'design-score',
		dictionaryId: '',
		title: {
			da: 'Designscore',
			kl: 'Ilusilersuinerup nalilernera',
		},
		type: 'number',
		unit: null,
		initialValue: 1
	},
	{
		id: 'number-of-owners',
		dictionaryId: '',
		title: {
			da: 'Ejere',
			kl: 'Piginnittut',
		},
		type: 'number',
		unit: null,
		initialValue: 3
	},
	{
		id: 'number-of-partners',
		dictionaryId: '',
		title: {
			da: 'Partnere',
			kl: 'Suleqatigisat',
		},
		type: 'number',
		unit: null,
		initialValue: 0
	},
	{
		id: 'additional-salaries',
		dictionaryId: '',
		title: {
			da: 'Ekstra lønudgifter',
			kl: 'Saniatigut akissarsiassanut aningaasartuutit',
		},
		type: 'number',
		unit: {
			da: 'kr',
			kl: 'kr',
		},
		initialValue: 0
	},
	{
		id: 'liquidity',
		dictionaryId: 'liquidity',
		title: {
			da: 'Likviditet',
			kl: 'Akiliisinnaassuseqarneq',
		},
		type: 'number',
		unit: {
			da: 'kr',
			kl: 'kr',
		},
		initialValue: 30000
	},



	/* Basic stats - affected by selected actions and/or ending a round - hidden modifiers */
	{
		id: 'quality-score-modifier',
		dictionaryId: '',
		modifiesStatId: 'quality-score',
		type: 'add',
		initialValue: 0,
		isModifier: true
	},
	{
		id: 'prod-capacity-modifier',
		dictionaryId: '',
		modifiesStatId: 'prod-capacity',
		type: 'multiply',
		initialValue: 1,
		isModifier: true
	},
	{
		id: 'sales-price-selected',
		dictionaryId: '',
		initialValue: null,
		type: 'change',
		isModifier: true
	},
	{
		id: 'purchase-selected',
		dictionaryId: '',
		initialValue: null,
		type: 'change',
		isModifier: true
	},
	{
		id: 'supplier-selected',
		initialValue: null,
		type: 'change',
		isModifier: true
	},


	/* Calculated stats (not saved in game stats object) */
	{
		id: 'design-quality',
		dictionaryId: 'design-quality',
		title: {
			da: 'Design og kvalitet',
			kl: 'Ilusaa pitsaassuserlu',
		},
		type: 'range',
		minVal: 1,
		maxVal: 10,
	},
	{
		id: 'customers',
		dictionaryId: 'dict-customers',
		title: {
			da: 'Kunder dette kvartal',
			kl: 'Ukiup sisamararterutaani uani pisiniartut',
		},
		type: 'number',
		unit: null,
	},
	{
		id: 'buying-customers',
		dictionaryId: 'dict-buying-customers',
		title: {
			da: 'Andel der køber',
			kl: 'Taakkunani pisisut',
		},
		type: 'number',
		unit: {
			da: '%',
			kl: '%',
		},
	},
	{
		id: 'design-expenses',
		dictionaryId: '',
		title: {
			da: 'Udgifter til design',
			kl: 'Ilusilersuinermut aningaasartuutit',
		},
		type: 'number',
		unit: {
			da: 'kr',
			kl: 'kr',
		},
	},
	{
		id: 'quality-score',
		dictionaryId: '',
		title: {
			da: 'Kvalitetsscore',
			kl: 'Pitsaassutsip nalilernera',
		},
		type: 'number',
		unit: null,
	},
	{
		id: 'prod-capacity',
		dictionaryId: 'prod-capacity',
		title: {
			da: 'Prod.-kapacitet',
			kl: 'Nioqqutissat amerlassuserisinnaasaat',
		},
		type: 'number',
		unit: {
			da: 'stk',
			kl: '-nik amerlassusillit',
		},
	},
	{
		id: 'purchase',
		dictionaryId: '',
		title: {
			da: 'Indkøb',
			kl: 'Pisiniarneq',
		},
		type: 'number',
		unit: {
			da: 'stk',
			kl: '-nik amerlassusillit',
		},
	},
	{
		id: 'sales-price',
		dictionaryId: '',
		title: {
			da: 'Salgspris',
			kl: 'Tuninerani akia',
		},
		type: 'number',
		unit: {
			da: 'kr',
			kl: 'kr',
		},
	},
];

module.exports = {
	statsData
};